import React from "react";
import { Modal } from "react-bootstrap"; // or your preferred modal library

const ErrorModal = ({ isError, errorMessage, onClose }) => {
  if (!isError) return null;

  return (
    <div
          className="modal upgrade-plan cancel-subscription-modal updated-successfully-modal canceled-successfully show fade"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="successModalLabel"
          aria-hidden="false"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="upgrade-plan-content text-center">
              <img
          src={require("../../assets/images/info-orange.svg")}
          
          alt="Error!"
        />
                <span className="loading-msg d-block success-msg">
                  {errorMessage}
                </span>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="modal-btn confirm-btn ok-btn"
                  onClick={onClose}
                >
                  OKAY
                </button>
              </div>
            </div>
          </div>
        </div>
  );
};



export default ErrorModal;
